module.exports = __webpack_public_path__ + "img/E12.263324dd.png";